import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import { ContentProvider } from "@/context/ContentContext";
import { ThemeApplier } from "@/components/builder/ThemeApplier";
import { BuilderToolbar } from "@/components/builder/BuilderToolbar";
import { CookieConsent } from "@/components/CookieConsent";
import { initGA, trackPageView } from "@/lib/analytics";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <ContentProvider>
      <ThemeApplier />
      <div className="App">
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/termini" element={<Terms />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <BuilderToolbar />
        <CookieConsent />
        <Toaster position="top-center" richColors closeButton />
      </div>
    </ContentProvider>
  );
}

export default App;
